import React from 'react'
import { ListItem } from '../templates'
import mapType from '../mapType'
import TYPE from '../../../api/types'

const Artists = ({ data }) => {
  return (
    <div>
      {data.map(({ data, media, id }) => (
        <ListItem
          image={media[0]}
          title={data.title}
          description={`${data.country}, ${data.genre}`}
          key={id}
        />
      ))}
    </div>
  )
}

Artists.defaultProps = {
  data: [],
}

export default mapType(TYPE.ARTIST)(Artists)
